var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 1.25H1.875C0.839844 1.25 0 2.08984 0 3.125V16.875C0 17.9102 0.839844 18.75 1.875 18.75H18.125C19.1602 18.75 20 17.9102 20 16.875V3.125C20 2.08984 19.1602 1.25 18.125 1.25ZM1.875 3.59375C1.875 3.33594 2.08594 3.125 2.34375 3.125H3.90625C4.16406 3.125 4.375 3.33594 4.375 3.59375V4.53125C4.375 4.78906 4.16406 5 3.90625 5H2.34375C2.08594 5 1.875 4.78906 1.875 4.53125V3.59375ZM18.125 16.6406C18.125 16.7695 18.0195 16.875 17.8906 16.875H2.10938C1.98047 16.875 1.875 16.7695 1.875 16.6406V6.5625H18.125V16.6406ZM18.125 4.53125C18.125 4.78906 17.9141 5 17.6562 5H6.71875C6.46094 5 6.25 4.78906 6.25 4.53125V3.59375C6.25 3.33594 6.46094 3.125 6.71875 3.125H17.6562C17.9141 3.125 18.125 3.33594 18.125 3.59375V4.53125Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a04cd162.svg";
export { ForwardRef as ReactComponent };